import PropTypes from 'prop-types';
import React from "react";
import styles from './steps.module.scss';

function getStepClass(index, currentValue) {
    const classes = [styles.middle]
    if (index < currentValue) classes.push(styles.completed)
    else if (index == currentValue) classes.push(styles.active)
    return classes.join(' ')
}

const Steps = ({ currentStep, items }) => {
    return (
        <div className={styles.wrapper}>
            <ul className={styles.steps}>
                {items.map((data, index) => {
                    return (
                        <li className={styles.step} key={index}>
                            <div className={styles.content}>{data.title}</div>
                            <div className={styles.indicatorWrapper}>
                                <a className={getStepClass(data.status, currentStep)} >
                                    <div className={styles.inner} >{data?.icon}</div>
                                </a>
                            </div>
                        </li >
                    )
                })}
            </ul >
        </div >
    )
}

Steps.propTypes = {
    currentStep: PropTypes.number,
    items: PropTypes.array,
}

export default Steps